// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"798c3b0b","694":"99bfe772"}[chunkId] + ".chunk.css";
};